<script setup lang="ts">
import { useHead } from '#app/composables/head';

useHead({
  bodyAttrs: {
    class: 'bg-cream-200',
  },
});
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <header class="py-3 md:py-4 bg-white border-b border-cream-300">
      <div
        class="max-w-healthy-recipe-content-width mx-auto flex items-center md:justify-start justify-center"
      >
        <div class="shrink-0">
          <NuxtLink to="/"
            ><AtomsDietPlusLogo class="w-[100px] md:w-[208px]"
          /></NuxtLink>
        </div>
      </div>
    </header>

    <div class="md:border-t border-gray-300 md:pt-5 pb-5 flex-grow">
      <div
        class="md:flex max-w-healthy-recipe-content-width mx-auto justify-between"
      >
        <slot />
      </div>
    </div>

    <OrganismsDietplusHealthyRecipeFooter />
  </div>
</template>
